import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=559e063f&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=ts"
export * from "./Dashboard.vue?vue&type=script&lang=ts"
import style0 from "./Dashboard.vue?vue&type=style&index=0&id=559e063f&prod&lang=css"
import style1 from "./Dashboard.vue?vue&type=style&index=1&id=559e063f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559e063f",
  null
  
)

export default component.exports